import React, { useCallback, useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import noImage from "../../assets/images/no_image.jpg";
import * as utils from "../../Utils/comman";

function View(props) {
  const [typeCode, setTypeCode] = useState([]);
  let vendorType = "";
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";

  const { rowData } = props;

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
      rowData: {},
    };
    props.onChange(propdata);
  };

  const getTypeCode = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("vendor_type", vendorType);
    utils
      .callAPI("post", `/sales/getTypeCode`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setTypeCode(res);
        } else {
          setTypeCode([]);
        }
      })
      .catch((err) => {
        setTypeCode([]);
      });
  };

  useEffect(() => {
    getTypeCode();
  }, [vendorType]);

  const handleScanClick = useCallback((row) => async () => {
    const propdata = {
      mode: "scan",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleTransactionClick = useCallback((row) => async () => {
    const propdata = {
      mode: "transaction",
      rowData: row,
    };
    props.onChange(propdata);
  });

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h4></h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
            {["Distributor", "Dealer", "Retailer"].includes(props?.heading) && (
              <>
                <RB.Button
                  className="btn btn-outline-dark ms-2"
                  onClick={handleScanClick(rowData)}
                >
                  Scan Coupon
                </RB.Button>

                <RB.Button
                  className="btn btn-outline-dark ms-2"
                  onClick={handleTransactionClick(rowData)}
                >
                  Transaction Detail
                </RB.Button>
              </>
            )}
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {/* <RB.Row className="mb-3">
            {rowData?.distributor_name && (
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Distributor Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData?.distributor_name}
                </p>
              </RB.Col>
            )}
            {rowData.dealer_name && (
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Dealer Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.dealer_name}
                </p>
              </RB.Col>
            )}
          </RB.Row> */}

          {rowData?.channel_partner_type && (
            <>
              <h6>Channel Details</h6>
              <hr className="hr-lg mt-1" />
            </>
          )}
          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                {rowData?.channel_partner_type && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Channel Partner
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.channel_partner_type}
                    </p>
                  </RB.Col>
                )}
                {rowData?.channel_partner_id_name && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Channel Partner Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.channel_partner_id_name}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
            </RB.Col>
          </RB.Row>

          <>
            <h6>Basic Information</h6>
            <hr className="hr-lg mt-1" />
          </>
          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                {rowData?.companyName && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Company Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.companyName}
                    </p>
                  </RB.Col>
                )}
                {rowData.contactNo && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Contact Person
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.contactNo}
                    </p>
                  </RB.Col>
                )}

                {rowData.contactNo && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      {vendorType + " Code"}
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.code}
                    </p>
                  </RB.Col>
                )}

                {rowData.vendor_type && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Vendor Type
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.vendor_type}
                    </p>
                  </RB.Col>
                )}

                {rowData.zone && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Zones
                    </span>
                    <div>
                      <span className="fw-medium text-sm fw-semibold">
                        {rowData.zone.split(",").join(", ")}
                      </span>
                    </div>
                  </RB.Col>
                )}

                {rowData.gst_no && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      GST Number
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.gst_no}
                    </p>
                  </RB.Col>
                )}

                {rowData.trade_type && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Trade or Non-Trade
                    </span>
                    <span className="fw-medium text-sm fw-semibold">
                      <ul className=" ps-3 me-2  ">
                        {rowData.trade_type.split(",").map((trade, index) => (
                          <li> {trade}</li>
                        ))}
                      </ul>
                    </span>
                  </RB.Col>
                )}
              </RB.Row>
            </RB.Col>
          </RB.Row>

          <>
            <h6>Contact Details</h6>
            <hr className="hr-lg mt-1" />
          </>
          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                {rowData?.authorised_person_name && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Authorised Person Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.authorised_person_name}
                    </p>
                  </RB.Col>
                )}
                {rowData.authorised_designation && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Designation
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.authorised_designation}
                    </p>
                  </RB.Col>
                )}

                {rowData.authorised_contact_no && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Mobile No
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.authorised_contact_no}
                    </p>
                  </RB.Col>
                )}

                {rowData.authorised_email && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Email
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.authorised_email}
                    </p>
                  </RB.Col>
                )}

                {rowData.gst_no && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      GST Number
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.gst_no}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
              <>
                <h6>Joining Date</h6>
                <hr className="hr-lg mt-1" />
              </>
              <RB.Row className="mb-3">
                {rowData.joining_date && (
                  <RB.Col md={6}>
                    {/* <span className="text-uppercase fw-bold small text-body-secondary">
                      Joining Date
                    </span> */}
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.joining_date}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
              <>
                <h6>Payment Terms</h6>
                <hr className="hr-lg mt-1" />
              </>
              <RB.Row className="mb-3">
                {rowData.payment_terms && (
                  <RB.Col md={6}>
                    {/* <span className="text-uppercase fw-bold small text-body-secondary">
                      Payment Terms
                    </span> */}
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.payment_terms}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
              <>
                <h6>Credit Limit</h6>
                <hr className="hr-lg mt-1" />
              </>
              <RB.Row>
                {rowData.credit_limit && (
                  <RB.Col md={6}>
                    {/* <span className="text-uppercase fw-bold small text-body-secondary">
                      Credit Limit
                    </span> */}
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.credit_limit}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
              {rowData.deposit_amount && (
                <>
                  <h6>Deposit Amount</h6>
                  <hr className="hr-lg mt-1" />

                  <RB.Row>
                    {rowData.deposit_amount && (
                      <RB.Col md={6}>
                        {/* <span className="text-uppercase fw-bold small text-body-secondary">
                      Credit Limit
                    </span> */}
                        <p className="fw-medium text-sm fw-semibold">
                          {rowData.deposit_amount}
                        </p>
                      </RB.Col>
                    )}
                  </RB.Row>
                </>
              )}
            </RB.Col>
          </RB.Row>

          <>
            <h6>Registration Office </h6>
            <hr className="hr-lg mt-1" />
          </>
          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                {rowData?.company_address && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Address
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.company_address}
                    </p>
                  </RB.Col>
                )}
                {rowData.company_state && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      State
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.company_state}
                    </p>
                  </RB.Col>
                )}

                {rowData.company_district && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      District
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.company_district}
                    </p>
                  </RB.Col>
                )}

                {rowData.company_city && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      City
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.company_city}
                    </p>
                  </RB.Col>
                )}

                {rowData.company_pincode && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      GST Number
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.company_pincode}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
              <>
                <h6>Joining Date</h6>
                <hr className="hr-lg mt-1" />
              </>
              <RB.Row className="mb-3">
                {rowData.joining_date && (
                  <RB.Col md={6}>
                    {/* <span className="text-uppercase fw-bold small text-body-secondary">
                      Joining Date
                    </span> */}
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.joining_date}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
              <>
                <h6>Payment Terms</h6>
                <hr className="hr-lg mt-1" />
              </>
              <RB.Row className="mb-3">
                {rowData.payment_terms && (
                  <RB.Col md={6}>
                    {/* <span className="text-uppercase fw-bold small text-body-secondary">
                      Payment Terms
                    </span> */}
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.payment_terms}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
            </RB.Col>
          </RB.Row>

          {rowData.cl_bankName ||
          rowData.cl_accountHolderName ||
          rowData.cl_accountNumber ||
          rowData.cl_ifscCode ? (
            <>
              <div className="d-flex justify-content-between align-items-center">
                <h6 className="mt-2">Bank Details</h6>
              </div>
              <hr className="hr-lg mt-1" />
            </>
          ) : null}

          <RB.Row className="mb-3">
            {rowData.cl_bankName && (
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Bank Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.cl_bankName}
                </p>
              </RB.Col>
            )}
            {rowData.cl_accountHolderName && (
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Account Number
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.cl_accountHolderName}
                </p>
              </RB.Col>
            )}

            {rowData.cl_accountNumber && (
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Account Number
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.cl_accountNumber}
                </p>
              </RB.Col>
            )}

            {rowData.cl_ifscCode && (
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  IFSC Code
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.cl_ifscCode}
                </p>
              </RB.Col>
            )}
          </RB.Row>
          {(rowData.cl_aadharCardNo ||
            rowData.cl_panCardNo ||
            rowData.cl_document) && (
            <>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <h6>Document Information</h6>
              </div>
              <hr className="hr-lg mt-1" />
              <RB.Row>
                <RB.Col md={2}>
                  <RB.Row>
                    <div className="col-md-10 text-center mb-3">
                      <div className="profile-photo rounded mb-3">
                        {rowData.cl_document ? (
                          <a
                            href={rowData.cl_document}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={rowData.cl_document}
                              className="img-fluid rounded"
                              alt="Document"
                              style={{ cursor: "pointer" }}
                            />
                          </a>
                        ) : (
                          <div className="text-muted">No Document</div>
                        )}
                      </div>
                    </div>
                  </RB.Row>
                </RB.Col>
                <RB.Col md={10}>
                  <RB.Row className="mb-3">
                    {rowData.cl_aadharCardNo && (
                      <RB.Col md={4}>
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Aadhar Card Number
                        </span>
                        <p className="fw-medium text-sm fw-semibold">
                          {rowData.cl_aadharCardNo}
                        </p>
                      </RB.Col>
                    )}
                    {rowData.cl_panCardNo && (
                      <RB.Col md={4}>
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Pan Card Number
                        </span>
                        <p className="fw-medium text-sm fw-semibold">
                          {rowData.cl_panCardNo}
                        </p>
                      </RB.Col>
                    )}
                  </RB.Row>
                </RB.Col>
              </RB.Row>
            </>
          )}

          {rowData.security_attchment ? (
            <>
              {rowData.security_attchment &&
                rowData.security_attchment.length > 0 && (
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Security Cheques
                  </span>
                )}
              <RB.Row className="mt-2">
                {rowData.security_attchment &&
                  rowData.security_attchment.length > 0 && (
                    <RB.Row className="mt-2">
                      {rowData.security_attchment
                        .filter((fileUrl) => {
                          const ext = fileUrl?.split(".").pop().toLowerCase();
                          return [
                            "jpg",
                            "jpeg",
                            "png",
                            "pdf",
                            "doc",
                            "docx",
                            "xls",
                            "xlsx",
                          ].includes(ext);
                        })
                        .map((fileUrl, index) => {
                          const ext = fileUrl?.split(".").pop().toLowerCase();
                          const isImage = ["jpg", "jpeg", "png"].includes(ext);

                          return (
                            <RB.Col md={4} key={index}>
                              <div className="document-image rounded mb-3 text-center">
                                {isImage ? (
                                  <img
                                    src={fileUrl || noImage}
                                    className="img-fluid rounded"
                                    alt="document"
                                  />
                                ) : (
                                  <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-block"
                                  >
                                    📎 {ext.toUpperCase()} File
                                  </a>
                                )}
                              </div>
                            </RB.Col>
                          );
                        })}
                    </RB.Row>
                  )}
              </RB.Row>
            </>
          ) : null}

          <>
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mt-2">Terms and Condition</h6>
            </div>
            <hr className="hr-lg mt-1" />
            <RB.Row>
              {rowData?.terms_conditions && (
                <RB.Col md={12}>
                  {/* <span className="text-uppercase fw-bold small text-body-secondary">
                      Credit Limit
                    </span> */}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: rowData.terms_conditions,
                    }}
                  />
                </RB.Col>
              )}
            </RB.Row>

            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mt-2">Assigned Sales Person</h6>
            </div>
            <hr className="hr-lg mt-1" />
            <RB.Row>
              {rowData.assign_sales_persons && (
                <RB.Col md={6}>
                  {/* <span className="text-uppercase fw-bold small text-body-secondary">
                      Credit Limit
                    </span> */}

                  {rowData.assign_sales_persons_nm
                    .split(",")
                    .map((person, index) => (
                      <ul className=" ps-3 me-2  ">
                        <li> {person}</li>
                      </ul>
                    ))}
                </RB.Col>
              )}
            </RB.Row>
          </>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default View;
